import React from 'react';
import { ListGroup, ListGroupItem } from 'shards-react';
import QaListItem from './QaListItem';
import useLocales from '../../../hooks/useLocales';
import type { QaItem } from '../../../types/qa';

interface QaListProps {
  items: QaItem[];
}

const QaList = ({ items }: QaListProps): React.ReactElement => {
  const { currentLang } = useLocales();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log(selectedTab);
  // }, [selectedTab]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ListGroup>
      {items.length ? (
        items.filter((item) => item.question[currentLang.value] !== '').map((item, idx) => <QaListItem key={'item-' + item.category + idx} item={item} language={currentLang.value} />)
      ) : (
        <ListGroupItem>No QA Item</ListGroupItem>
      )}
    </ListGroup>
  );
};

export default QaList;
